import { AutomatedEmailCampaignType } from 'wisestep-api';
import { WsTypoVariants } from 'wisestep-base';

import { CampaignLayout, SectionHeaders } from '../../components';
import { campaignHeaderHelper } from '../../utils';

export const DefaultCampaign = () => {
  const headerInfo = campaignHeaderHelper['emailCheck'];
  return (
    <CampaignLayout
      header={
        <SectionHeaders
          title={headerInfo.header}
          subTitle={headerInfo.subHeader}
          titleVariant={WsTypoVariants.TITLE}
        />
      }
      layoutType={AutomatedEmailCampaignType.DEFAULT}
    />
  );
};
